// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n.wd260 {\n  width: 260px !important;\n}\n.notifyButton {\n  padding: 5px 30px;\n  background-color: #3498db;\n  /* 设置背景颜色为蓝色 */\n  color: white;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  border-radius: 5px;\n}\n.notifyTitle {\n  font-size: 20px;\n  margin-top: 10px;\n  margin-bottom: 5px;\n  color: #f59a23;\n}\n.notifyContent {\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
